import React, { useContext, useMemo } from 'react'
import { Card, FlexView, Button } from '../../../components/common'
import FilterableTable from 'app-components/common/FilterableTable'
import styled from 'styled-components'
import { JobContext } from 'stores/JobStore'
import { useTranslation } from 'react-i18next'

const BoxlessTable = styled(FilterableTable)`
box-shadow: none;
margin: 0px;
width: 100%; 

table {
  width: 100%;
  height: 100%;
  white-space: nowrap;
  th, td {
    text-align: left;
    border-right: 0;
  }
}
`

const FlexPadding = styled(FlexView)`
    padding: 0px 10px 20px 20px;
    flex-wrap: wrap;
`

const PipeLists = () => {
  const { jobPipes, exportAllPipeDataToExcel } = useContext(JobContext)
  const { t } = useTranslation()

  const tableColumns = useMemo(() => [
    {
      Header: t('Material'),
      accessor: 'material',
    },
    {
      Header: t('materialCode'),
      accessor: 'cod_material',
    },
    {
      Header: t('Tally No'),
      accessor: 'tally_number',
    },
    {
      Header: t('IPPN'),
      accessor: 'tracking_number',
    },
    {
      Header: t('IPPN DV'),
      accessor: 'tracking_number_dv',
    },
    {
      Header: t('Effective Length'),
      accessor: 'effective_length',
    },
    {
      Header: t('Overall Length'),
      accessor: 'overall_length',
    },
    {
      Header: t('Type'),
      accessor: 'type',
    },
    {
      Header: t('Status'),
      accessor: 'status',
    },
    {
      Header: t('location_status'),
      accessor: 'location_status',
    },
    {
      Header: t('receive_date'),
      accessor: 'delivered_scan_date',
    },
    {
      Header: t('downhole_scan_date'),
      accessor: 'downhole_scan_date',
    },
    {
      Header: t('Connection'),
      accessor: 'thread',
    },
    {
      Header: t('Comments'),
      accessor: 'comments',
    }
  ], [t])

  return (
    <FlexPadding flexDirection="row">
      <FlexView flexDirection="row" width="100%">
        <Card width="95%" elevation="high">
          <FlexView width="100%" justifyContent="flex-end" flexDirection="row">
            <Button backgroundColor="primary" color="white" onClick={() => exportAllPipeDataToExcel()}>{t('Export')}</Button>
          </FlexView>
          <BoxlessTable columns={tableColumns} data={jobPipes} sortable="true" paginated="true"></BoxlessTable>
        </Card>
      </FlexView>
    </FlexPadding>
  )
}

export default PipeLists